module.exports = __webpack_public_path__ + "img/checked-icon.036ddf01.png";